import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserService } from './users.service';
import { StateService } from './state.service';

const SERVICES = [
  UserService,
  StateService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
// export class DataModule {
//   static forRoot(): ModuleWithProviders {
//     return <ModuleWithProviders>{
//       ngModule: DataModule,
//       providers: [
//         ...SERVICES,
//       ],
//     };
//   }
// }
export class DataModule {
  static forRoot(): ModuleWithProviders<DataModule> {
    return {
      ngModule: DataModule,
      providers: [
        ...SERVICES
      ],
    };
  }
}

